// ============================================================================= //
//  JS detection
// ============================================================================= //
document.body.classList.remove("no-js");

// ============================================================================= //
//  Modules
// ============================================================================= //
import "./modules/category-filters";
import "./modules/mobile-navigation";
import "./modules/site-header";
import "./modules/site-search";
import "./modules/smooth-scroll";
import "./modules/counters";
import "./modules/stickyColumns";
import "./modules/swiper";
import "./modules/video";
import "./modules/flip";
import "./modules/gallery-filter";
import "./modules/scroll-up";

stickMe.init({ offset: 48 });

